// RegExpRoute.jsx
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

const DEFAULT_REG_EXP = /.*/;

export const RegExpRoute = ({ regExp = DEFAULT_REG_EXP, element }) => {
  const location = useLocation();
  if (regExp.test(location.pathname)) {
    return element;
  } else {
    return null;
  }
};

RegExpRoute.propTypes = {
  element: PropTypes.element.isRequired,
  regExp: PropTypes.object,
};

export default RegExpRoute;
